export const LINUX_SCAN_COMMAND = `cnspec scan local`;
